import actions from './actions';

const initState = {
    couponInfo : {},
    coupons   : {
        data: []
    },
    loading : false,
    couponDeleted : false
};

export default function fetchCouponsReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_COUPONS_REQUESTED:
            return {
                ...state,
                coupons   : {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_COUPONS_SUCCEEDED:
            return {
                ...state,
                coupons    : action.coupons,
                loading     : false
            };
        case actions.FETCH_COUPONS_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.FETCH_COUPON_REQUESTED:
            return {
                ...state,
                couponInfo : {},
                loading : true
            };
        case actions.FETCH_COUPON_SUCCEEDED:
            return {
                ...state,
                couponInfo: action.coupon,
                loading     : false
            };
        case actions.FETCH_COUPON_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.DELETE_COUPON_REQUESTED:
            return {
                ...state,
                loading : true
            };
        case actions.DELETE_COUPON_SUCCEEDED:
            return {
                ...state,
                couponDeleted: true,
                loading: false
            };
        case actions.DELETE_COUPON_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.CLEAR_COUPON:
            return initState
        default:
            return state;
    }
}
